import { FULL_DEAL_ENTRY_POINT_TEXTS } from '../config/texts';

const CONTINUE_DEAL_BUTTON_TEXT = 'Продолжить оформление';

export function formatToFullDealButtonText(text: string): string {
  if (text.trim() === CONTINUE_DEAL_BUTTON_TEXT) {
    return FULL_DEAL_ENTRY_POINT_TEXTS.completeDeal;
  }

  return text;
}
